module.exports = __webpack_public_path__ + "img/22.e7886b9f.jpg";